<div class="add-button">
  <p>+</p>
  <span></span>
</div>
